import {API, getGraphQLPath} from '@/lib/utils/api.utils';
import {extractPriceDetails} from '@/lib/utils/price.utils';
import {PriceEngineQuery, Maybe, LineOfferReq, Currency} from 'epic-graphql-types';

const query = `
    query priceQuery(
        $country: String!
        $locale: String!
        $namespace: String!
        $lineOffers: [LineOfferReq]!,
        $identityId: String!
    ) {
        PriceEngine {
            price(namespace: $namespace, country: $country, lineOffers: $lineOffers, identityId: $identityId) {
                totalPrice {
                    discountPrice
                    originalPrice
                    discount
                    currencyCode
                    currencyInfo {
                        decimals
                        code
                    }
                    fmtPrice(locale: $locale) {
                        originalPrice
                        discountPrice
                    }
                }
            }
        }
    }
`;

interface PriceQueryProps {
	country: string;
	namespace: string;
	lineOffers: LineOfferReq[];
	identityId?: string;
	locale: string;
}

interface PriceQueryRes {
	data: PriceQueryResData;
}

interface PriceQueryResData {
	PriceEngine?: PriceEngineQuery;
}

export const createPriceKey = (request: PriceQueryProps): string => {
	return JSON.stringify(request);
};

export interface PriceRes {
	priceDisplay: string;
	isSale: boolean;
	isFree: boolean;
	hasPrice: boolean;
	currencyCode?: Maybe<string>;
	fetched: boolean;
	currencyInfo?: Maybe<Currency>;
}

export const getPrice = async (variables: PriceQueryProps): Promise<PriceRes> => {
	try {
		console.log('PriceFetch.getPrice() fetching...', variables);
		const response = await API<PriceQueryRes>(getGraphQLPath(), {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			withCredentials: true,
			data: {
				query,
				variables
			}
		});

		const responseData = response?.data?.data || {};

		const PriceEngine = responseData.PriceEngine || {};
		const price = PriceEngine.price || {};
		const totalPrice = price.totalPrice || {};

		console.log('PriceFetch.getPrice() success', totalPrice);

		return {
			...(extractPriceDetails(price) as PriceRes),
			fetched: true
		};
	} catch (err) {
		console.error('getPrice() failed to load');
		throw err;
	}
};
